import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { DreamSearchItemFragmentFragmentDoc } from '../../health/_components/generated';
export type DreamSearchForHomePageQueryVariables = Types.Exact<{
  dreamSearchFilters: Types.DreamSearchFilters;
  geo: Types.DreamSearchGeo;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  complianceExclusionTags: Array<Types.Scalars['String']['input']>;
}>;


export type DreamSearchForHomePageQuery = { __typename?: 'Query', dreamSearchItemsConnection: { __typename?: 'QueryDreamSearchItemsConnection_Connection', city: string, state: string, zip: string, nodes: Array<{ __typename?: 'DreamSearchItem', id: string, score: number, distance: number, favorited: boolean, label: Types.ProgramTag | null, provider: { __typename?: 'Provider', id: string, fullName: string, isPartnered: boolean, slug: string, complianceExclusionTags: Array<string>, logoImageFile: { __typename?: 'ImageFile', id: string, url: string | null } | null, publicDisplayFields: { __typename?: 'ProviderPublicDisplayFields', id: string, aboutSchool: string | null } | null, geocode: { __typename?: 'Geocode', id: string, point: {
            lat: number;
            long: number;
          } }, detailsMap: { __typename?: 'ProviderDetailMap', id: string, logoPalette: { __typename?: 'LogoPalette', muted: string | null } | null } }, program: { __typename?: 'Program', id: string, environment: Types.ProgramEnvironment, environmentCompliance: boolean, name: string, slug: string, customCtaCopy: string | null, preLeadRedirect: string | null, preLeadRedirectParams: {
          [key: string]: any;
        } | null, preLeadRedirectCompositeParams: {
          [key: string]: any;
        } | null, preLeadRedirectSuppressDefaultParams: boolean | null, preLeadRedirectInIframe: boolean | null, allowHybridSignup: boolean, programHighlights: Array<string>, tags: Array<Types.ProgramTag>, programLevel: Types.ProgramLevel, publicDisplayFields: { __typename?: 'ProgramPublicDisplayFields', id: string, aboutProgramPlainText: string | null } | null, vocation: { __typename?: 'Vocation', id: string, abbreviation: string | null, adjective: string }, costs: Array<{ __typename?: 'ProgramCost', id: string, cost: number }>, eligiblePaymentOptions: Array<{ __typename?: 'PaymentOption', id: string, type: Types.PaymentOptionType, estimatedFirstPayment: number | null, isVisible: boolean, config: { __typename?: 'PaymentOptionConfig', id: string, description: string | null } }> } }> } };


export const DreamSearchForHomePageDocument = gql`
    query dreamSearchForHomePage($dreamSearchFilters: DreamSearchFilters!, $geo: DreamSearchGeo!, $first: Int!, $after: Int, $complianceExclusionTags: [String!]!) {
  dreamSearchItemsConnection(
    filter: $dreamSearchFilters
    geo: $geo
    first: $first
    after: $after
    complianceExclusionTags: $complianceExclusionTags
    includeFilterSettings: false
    includeOtherRecommendedItems: false
  ) {
    nodes {
      ...DreamSearchItemFragment
    }
    city
    state
    zip
  }
}
    ${DreamSearchItemFragmentFragmentDoc}` as unknown as DocumentNode<DreamSearchForHomePageQuery, DreamSearchForHomePageQueryVariables>;